import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import Link from 'portaltransparencia-common/components/link/Link.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableActions from 'portaltransparencia-common/components/TableActions.react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';

export default class ResponsavelTable extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    searchWithPage: PropTypes.func.isRequired,
    isIntegradoOxy: PropTypes.bool,
    findContrato: PropTypes.func.isRequired
  };

  showContrato = contrato => {
    const { isIntegradoOxy, findContrato } = this.props;

    const entidade = contrato.get('entidade');
    const exercicio = contrato.get('exercicioContrato');
    const codigoContrato = contrato.get('contrato');
    const tipoAto = contrato.get('tipoAto');

    if (isIntegradoOxy && findContrato) {
      findContrato(entidade, exercicio, codigoContrato, tipoAto).then(
        contratoResponse => {
          const { value } = contratoResponse;

          if (value?.idOxy) {
            window.open(`contratos/detalhes?id=${value.idOxy}`, '_blank');
          }
        }
      );
    } else {
      window.open(
        `contratos/detalhes?entidade=${entidade}&exercicio=${exercicio}&contrato=${codigoContrato}&tipoAto=${tipoAto}`,
        '_blank'
      );
    }
  };

  renderResponsaveis = responsavel => {
    const key = `${responsavel.get('exercicio')}_${responsavel.get(
      'contrato'
    )}_${responsavel.get('ocupante')}`;

    return (
      <TableActions ref="row" key={key} data={responsavel}>
        <td id="tableOcupante">{responsavel.get('ocupante')}</td>
        <td id="tableDescricaoCargo">{responsavel.get('descricaoCargo')}</td>
        <td id="tableTipoAto">{responsavel.get('descricaoTipoAto')}</td>
        <td id="tableNumeroContrato" style={{ whiteSpace: 'nowrap' }}>
          <Link
            onClick={this.showContrato}
            data={responsavel}
            value={responsavel.get('displayContrato')}
            icon="fa fa-external-link-square"
            iconPosition="right"
          />
        </td>
        <td id="tableDataInicio">
          {DateUtils.transform(responsavel.get('dataInicio'))}
        </td>
        <td id="tableDataTermino">
          {DateUtils.transform(responsavel.get('dataTermino'))}
        </td>
        <td id="tableVigencia">
          {DateUtils.transform(responsavel.get('vigencia'))}
        </td>
        <td id="tableSituacao">{responsavel.get('situacao')}</td>
      </TableActions>
    );
  };

  render() {
    const { page, searchWithPage, isIntegradoOxy } = this.props;
    let responsaveis = page.get('content');

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader
            empty={responsaveis.isEmpty()}
            text="Não foi encontrado nenhum responsável para a pesquisa selecionada."
          >
            <tr>
              <TableHeaderItem
                field={isIntegradoOxy ? 'p.nome' : 'ocupante'}
                label="Ocupante"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="descricaoCargo"
                label="Cargo"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={isIntegradoOxy ? 'c.tipoAto' : 'tipoAto'}
                label="Tipo Ato"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={isIntegradoOxy ? 'c.numeroContrato' : 'numeroContrato'}
                label="Nr. Contrato"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={
                  isIntegradoOxy ? 'vigencia.inicioVigencia' : 'dataInicio'
                }
                label="Dt. Início"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={
                  isIntegradoOxy ? 'vigencia.terminoVigencia' : 'dataTermino'
                }
                label="Dt. Término"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={
                  isIntegradoOxy ? 'c.periodo.terminoVigencia' : 'vigencia'
                }
                label="Dt. Final Vigência"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field={isIntegradoOxy ? 'c.situacao' : 'situacao'}
                label="Situação"
                page={page}
                searchWithPage={searchWithPage}
              />
            </tr>
          </TableHeader>

          <tbody>{responsaveis.map(this.renderResponsaveis)}</tbody>
        </table>
      </div>
    );
  }
}
